"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGQLConfig = exports.setGQLConfig = exports.getGQLClientOptions = exports.setGQLAuthToken = void 0;
const elements_core_i18n_1 = require("@hydrogen/elements.core.i18n");
let initGqlOptions = {
    headers: {
        'Accept': 'application/json'
    },
};
let GqlBaseUrl = '';
let urlSuffix = '';
const setGQLAuthToken = (token) => {
    initGqlOptions = Object.assign(Object.assign({}, initGqlOptions), { headers: Object.assign(Object.assign({}, initGqlOptions.headers), { 'Authorization': `Bearer ${token}` }) });
};
exports.setGQLAuthToken = setGQLAuthToken;
const getGQLClientOptions = () => {
    var _a, _b;
    initGqlOptions.headers['accept-language'] = (((_b = (_a = elements_core_i18n_1.i18n === null || elements_core_i18n_1.i18n === void 0 ? void 0 : elements_core_i18n_1.i18n.language) === null || _a === void 0 ? void 0 : _a.slice) === null || _b === void 0 ? void 0 : _b.call(_a, 0, 2)) || elements_core_i18n_1.DEFAULT_LANGUAGE);
    return initGqlOptions;
};
exports.getGQLClientOptions = getGQLClientOptions;
const setGQLConfig = (baseUrl, route) => {
    GqlBaseUrl = baseUrl;
    urlSuffix = route;
};
exports.setGQLConfig = setGQLConfig;
const getGQLConfig = () => ({
    serviceEndpoint: `${GqlBaseUrl + urlSuffix}/securities`,
    clientsEndpoint: `${GqlBaseUrl + urlSuffix}/clients`,
});
exports.getGQLConfig = getGQLConfig;
//# sourceMappingURL=setup.js.map